import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import { urnOf } from '@/models/urn';

/** URN pour écrire une relation vers cette ressource (corps d'un POST / PATCH) ; un filtre prend l'id */
export const companyUrn = (companyId: id | number) => urnOf('company', companyId);

/** Société (GET /companies) : lecture seule, créées par migration côté API ; timezone : fuseau IANA (heure légale des lignes) */
export default class CompanyModel extends AbstractApiModel {
  protected _path = '/companies/{?id}';

  /** members.user : sociétés dont un utilisateur est employé (sélecteur de la sidebar) */
  declare _tsFilters: { name?: string; 'members.user'?: string };
  declare _tsSorts: { name?: unknown };

  @doc.string declare name: string;
  @doc.string declare timezone: string;
}
